module.exports = __webpack_public_path__ + "img/ssyx_41.6171a4ae.jpg";